import { create } from "zustand";

interface StatusBarState {
  adapterType: string | null;
  model: string | null;
  sessionStatus: string | null;
  setSessionContext: (adapter: string | null, model: string | null, status: string | null) => void;
  clearSessionContext: () => void;
}

export const useStatusBarStore = create<StatusBarState>((set) => ({
  adapterType: null,
  model: null,
  sessionStatus: null,
  setSessionContext: (adapterType, model, sessionStatus) =>
    set({ adapterType, model, sessionStatus }),
  clearSessionContext: () =>
    set({ adapterType: null, model: null, sessionStatus: null }),
}));
